import { Bundle } from "./bundle";

export class UssdPricing {
  sessionBundles: Bundle[];
  extensionBundles: Bundle[];
  currency: string;
  sessionMinimumPurchase: number;
  sessionMultiplier: number;

  constructor() {
    this.sessionBundles = [];
    this.extensionBundles = [];
    this.currency = '';
    this.sessionMinimumPurchase = 0;
    this.sessionMultiplier = 0;
  }
}
